// 图书相关接口
import request from '@/utils/request'

// 图书详情接口
export function getBookDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/bookBasicInfoApi/getBookDetails?id=${id}`,
    method: 'get',
  })
}

// 图书加入书架接口
export function addBookShelf(id) {
  return request({
    url: `/cultureCantonDemoApi/bookShelfInfoApi/addUserBookShelf?bootId=${id}`,
    method: 'get',
  })
}
